/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExchangePlaidTokenRequest
 */
export interface ExchangePlaidTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof ExchangePlaidTokenRequest
     */
    plaidPublicToken: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExchangePlaidTokenRequest
     */
    isDefault: boolean;
}

/**
 * Check if a given object implements the ExchangePlaidTokenRequest interface.
 */
export function instanceOfExchangePlaidTokenRequest(value: object): value is ExchangePlaidTokenRequest {
    if (!('plaidPublicToken' in value) || value['plaidPublicToken'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    return true;
}

export function ExchangePlaidTokenRequestFromJSON(json: any): ExchangePlaidTokenRequest {
    return ExchangePlaidTokenRequestFromJSONTyped(json, false);
}

export function ExchangePlaidTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExchangePlaidTokenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'plaidPublicToken': json['plaidPublicToken'],
        'isDefault': json['isDefault'],
    };
}

export function ExchangePlaidTokenRequestToJSON(json: any): ExchangePlaidTokenRequest {
    return ExchangePlaidTokenRequestToJSONTyped(json, false);
}

export function ExchangePlaidTokenRequestToJSONTyped(value?: ExchangePlaidTokenRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plaidPublicToken': value['plaidPublicToken'],
        'isDefault': value['isDefault'],
    };
}

